import React from "react";
import { LockKeyholeIcon } from "lucide-react";

const AuthSpinner: React.FC<{
  size?: number;
  width?: number;
  color?: string;
}> = ({ size = 44, width = 3, color = "text-primary" }) => {
  const center = size / 2;
  const radius = (size - width) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = `${circumference * 0.75} ${circumference * 0.25}`;

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg
        className={`animate-spin ${color}`}
        viewBox={`0 0 ${size} ${size}`}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
      >
        <circle
          className="opacity-25"
          cx={center}
          cy={center}
          r={radius}
          stroke="currentColor"
          strokeWidth={width}
          fill="none"
        />
        <circle
          className="opacity-75"
          cx={center}
          cy={center}
          r={radius}
          stroke="currentColor"
          strokeWidth={width}
          strokeDasharray={strokeDasharray}
          strokeLinecap="round"
          fill="none"
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <LockKeyholeIcon className={color} size={size * 0.5} />
      </div>
    </div>
  );
};

export default AuthSpinner;
